import {
  FEATURE_INTRO_DATES,
  NewFeature,
} from "components/NewFeature/NewFeature";
import {
  CampaignCondition,
  CampaignConditionNewFormat,
  NewFormatConditionType,
} from "types/campaigns";
import { referralCustomerConditions } from "../campaignHelpers";

export const referralCampaignCustomerConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [
  ...referralCustomerConditions,
  {
    attribute: "referrer.activePoints",
    label: "referrerActiveWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "referrerActiveUnits",
    value: {
      field: "referrer.wallets.activeUnits",
      params: {
        field: "activeUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "referrer.averagePurchaseAmount",
    label: "referrerAvgTransactionValue",
    type: "float",
  },
  {
    attribute: "referrer.expiredPoints",
    label: "referrerExpiredWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "referrerExpiredUnits",
    value: {
      field: "referrer.wallets.expiredUnits",
      params: {
        field: "expiredUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "expression",
    label: "referrerExpression",
    operator: "expression",
    type: "expression",
  },
  {
    attribute: "referrer.firstTransactionDate",
    data: null,
    label: "referrerFirstTransactionDate",
    type: "datetime",
  },
  {
    attribute: "referrer.lastTransactionDate",
    data: null,
    label: "referrerLastTransactionDate",
    type: "datetime",
  },
  {
    attribute: "referrer.lockedPoints",
    label: "referrerLockedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "referrer.blockedPoints",
    label: "referrerBlockedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "referrerBlockedUnits",
    value: {
      field: "referrer.wallets.blockedUnits",
      params: {
        field: "blockedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "referrer.numberOfPurchases",
    label: "referrerNumberOfPurchases",
    type: "int",
  },
  {
    label: "referrerPendingUnits",
    value: {
      field: "referrer.wallets.lockedUnits",
      params: {
        field: "lockedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "referrer.earnedPoints",
    label: "referrerTotalEarnedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "referrerTotalEarnedUnits",
    value: {
      field: "referrer.wallets.earnedUnits",
      params: {
        field: "earnedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "referrer.purchaseAmount",
    label: "referrerTotalSpending",
    type: "float",
  },
  {
    attribute: "referrer.spentPoints",
    label: "referrerUsedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "referrerUsedUnits",
    value: {
      field: "referrer.wallets.spentUnits",
      params: {
        field: "spentUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "customer.activePoints",
    label: "refereeActiveWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "refereeActiveUnits",
    value: {
      field: "customer.wallets.activeUnits",
      params: {
        field: "activeUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "customer.averagePurchaseAmount",
    label: "refereeAvgTransactionValue",
    type: "float",
  },
  {
    attribute: "customer.expiredPoints",
    label: "refereeExpiredWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "refereeExpiredUnits",
    value: {
      field: "customer.wallets.expiredUnits",
      params: {
        field: "expiredUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "expression",
    label: "refereeExpression",
    operator: "expression",
    type: "expression",
  },
  {
    attribute: "customer.firstTransactionDate",
    data: null,
    label: "refereeFirstTransactionDate",
    type: "datetime",
  },
  {
    attribute: "customer.lastTransactionDate",
    data: null,
    label: "refereeLastTransactionDate",
    type: "datetime",
  },
  {
    attribute: "customer.lockedPoints",
    label: "refereeLockedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "customer.blockedPoints",
    label: "refereeBlockedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "refereeBlockedUnits",
    value: {
      field: "customer.wallets.blockedUnits",
      params: {
        field: "blockedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "customer.numberOfPurchases",
    label: "refereeNumberOfPurchases",
    type: "int",
  },
  {
    label: "refereePendingUnits",
    value: {
      field: "customer.wallets.lockedUnits",
      params: {
        field: "lockedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "customer.earnedPoints",
    label: "refereeTotalEarnedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "refereeTotalEarnedUnits",
    value: {
      field: "customer.wallets.earnedUnits",
      params: {
        field: "earnedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "customer.spentPoints",
    label: "refereeUsedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    label: "refereeUsedUnits",
    value: {
      field: "customer.wallets.spentUnits",
      params: {
        field: "spentUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    attribute: "customer.purchaseAmount",
    label: "refereeTotalSpending",
    type: "float",
  },
  {
    attribute: "executionContext.currentMultiLevel",
    data: null,
    label: "multiReferralLevelCondition",
    type: "int",
  },
  {
    label: "referrerBadges",
    value: {
      field: "referrer.badges",
      params: {
        field: "badgeTypeId",
      },
    },
    type: NewFormatConditionType.NUMBER,
    labelInfo: (
      <NewFeature featureIntroductionDate={FEATURE_INTRO_DATES.BADGES} />
    ),
  },
  {
    label: "refereeBadges",
    value: {
      field: "customer.badges",
      params: {
        field: "badgeTypeId",
      },
    },
    type: NewFormatConditionType.NUMBER,
    labelInfo: (
      <NewFeature featureIntroductionDate={FEATURE_INTRO_DATES.BADGES} />
    ),
  },
];

export const campaignCustomerConditions: CampaignConditionNewFormat[] = [
  {
    label: "memberBadges",
    value: {
      field: "customer.badges",
      params: {
        field: "badgeTypeId",
      },
    },
    type: NewFormatConditionType.NUMBER,
    labelInfo: (
      <NewFeature featureIntroductionDate={FEATURE_INTRO_DATES.BADGES} />
    ),
  },
];

export const customerConditions: CampaignCondition[] = [
  {
    attribute: "customer.address.address1",
    label: "buildingName",
    type: "text",
  },
  { attribute: "customer.address.city", label: "city", type: "text" },
  {
    attribute: "customer.address.country",
    label: "country",
    type: "countryDropdown",
  },
  {
    attribute: "customer.dataProcessingConsent",
    data: false,
    label: "dataProcessingConsent",
    operator: "is_equal",
    type: "boolean",
  },
  {
    attribute: "customer.birthDate",
    data: null,
    label: "dateOfBirth",
    type: "date",
  },
  { attribute: "customer.email", label: "email", type: "text" },
  { attribute: "customer.firstName", label: "firstName", type: "text" },
  {
    attribute: "customer.address.address2",
    label: "flatUnitName",
    type: "text",
  },
  { attribute: "customer.gender", label: "gender", type: "genderDropdown" },
  { attribute: "customer.lastName", label: "lastName", type: "text" },
  {
    attribute: "customer.legalConsent",
    data: false,
    label: "legalConsent",
    operator: "is_equal",
    type: "boolean",
  },
  {
    attribute: "customer.loyaltyCardNumber",
    label: "loyaltyCardNumber",
    type: "text",
  },
  {
    attribute: "customer.marketingConsent",
    data: false,
    label: "marketingConsent",
    operator: "is_equal",
    type: "boolean",
  },

  {
    attribute: "customer.labels",
    data: [],
    label: "memberCustomAttributes",
    type: "label",
  },
  {
    attribute: "customer.segments",
    label: "memberSegments",
    type: "segmentDropdown",
  },
  { attribute: "customer.phone", label: "phoneNumber", type: "text" },
  { attribute: "customer.address.postal", label: "postalCode", type: "text" },
  { attribute: "customer.address.province", label: "province", type: "text" },
  {
    attribute: "customer.registeredDate",
    data: null,
    label: "dateOfRegistration",
    type: "datetime",
  },
  { attribute: "customer.address.street", label: "street", type: "text" },
  {
    attribute: "customer.levelId",
    label: "tierFromDefaultTierset",
    type: "tierDropdown",
  },
  {
    attribute: "customer.tiers",
    label: "tiers",
    type: "tierDropdown",
  },
  {
    attribute: "customer.levelAchievementDate",
    data: null,
    label: "tierFromDefaultTierSetReachedDate",
    type: "datetime",
  },
];

export const directCustomerConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [
  ...customerConditions,
  ...campaignCustomerConditions,
  {
    attribute: "customer.activePoints",
    label: "activeWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "customer.averagePurchaseAmount",
    label: "avgTransactionValueWithCurrency",
    type: "float",
  },
  {
    attribute: "customer.expiredPoints",
    label: "expiredWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "expression",
    label: "expression",
    operator: "expression",
    type: "expression",
  },
  {
    attribute: "customer.firstTransactionDate",
    data: null,
    label: "firstTransactionDate",
    type: "datetime",
  },
  {
    attribute: "customer.lastTransactionDate",
    data: null,
    label: "lastTransactionDate",
    type: "datetime",
  },
  {
    attribute: "customer.lockedPoints",
    label: "pendingWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "customer.blockedPoints",
    label: "blockedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "customer.numberOfPurchases",
    label: "numberOfPurchases",
    type: "int",
  },
  {
    attribute: "customer.earnedPoints",
    label: "totalEarnedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "customer.spentPoints",
    label: "usedWalletUnits",
    type: "float",
    isDeprecated: true,
  },
  {
    attribute: "customer.purchaseAmount",
    label: "totalSpendingWithCurrency",
    type: "float",
  },
  {
    label: "activeUnits",
    value: {
      field: "customer.wallets.activeUnits",
      params: {
        field: "activeUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    label: "blockedUnits",
    value: {
      field: "customer.wallets.blockedUnits",
      params: {
        field: "blockedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    label: "expiredUnitsConst",
    value: {
      field: "customer.wallets.expiredUnits",
      params: {
        field: "expiredUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    label: "pendingUnitsConst",
    value: {
      field: "customer.wallets.lockedUnits",
      params: {
        field: "lockedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    label: "totalEarnedUnitsConst",
    value: {
      field: "customer.wallets.earnedUnits",
      params: {
        field: "earnedUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    label: "usedUnitsConst",
    value: {
      field: "customer.wallets.spentUnits",
      params: {
        field: "spentUnits",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
];

export const eventConditions: CampaignCondition[] = [
  {
    attribute: "event.eventDate",
    data: null,
    label: "eventDate",
    type: "datetime",
  },
  {
    attribute: "event.name",
    label: "eventName",
    type: "text",
  },
  {
    attribute: "event.body.levelId",
    label: "reachedTier",
    type: "tierDropdownSingle",
  },
];

export const achievementConditions: CampaignCondition[] = [
  {
    attribute: "event.body.achievementId",
    label: "achievement",
    type: "achievementDropdown",
  },
];

export const eventDirectCampaignConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [...directCustomerConditions, ...eventConditions];

export const achievementEventDirectCampaignConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [...eventDirectCampaignConditions, ...achievementConditions];

export const eventReferralCampaignConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [...referralCampaignCustomerConditions, ...eventConditions];

export const transactionConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [
  {
    attribute: "transaction.maker.grossValue",
    label: "transactionBrandGrossValue",
    type: "float",
  },
  {
    attribute: "transaction.maker.qty",
    label: "transactionBrandQty",
    type: "int",
  },
  {
    attribute: "transaction.category.grossValue",
    label: "transactionCategoryGrossValue",
    type: "float",
  },
  {
    attribute: "transaction.category.qty",
    label: "transactionCategoryQty",
    type: "int",
  },
  {
    attribute: "transaction.purchasedAt",
    label: "transactionDocumentDate",
    type: "datetime",
    data: null,
  },
  {
    attribute: "transaction.documentNumber",
    label: "transactionDocumentNumber",
    type: "text",
  },
  {
    attribute: "transaction.grossValue",
    label: "transactionValueWithCurrency",
    type: "float",
  },
  {
    attribute: "transaction.itemLabels",
    data: [],
    label: "productCustomAttribute",
    type: "label",
  },
  {
    attribute: "transaction.purchasePlace",
    label: "transactionPurchasePlace",
    type: "text",
  },
  { attribute: "transaction.qty", label: "transactionQty", type: "int" },
  {
    attribute: "transaction.shippingCity",
    label: "transactionDeliveryCity",
    type: "text",
  },
  {
    attribute: "transaction.sku.grossValue",
    label: "transactionSKUGrossValue",
    type: "float",
  },
  {
    attribute: "transaction.sku.qty",
    label: "transactionSKUQty",
    type: "int",
  },
  {
    attribute: "transaction.labels",
    data: [],
    label: "transactionCustomAttribute",
    type: "label",
  },
  {
    attribute: "transaction.channelId",
    label: "transactionChannel",
    type: "channelDropdown",
  },
  {
    attribute: "transaction.itemsCriteria.grossValue",
    data: null,
    label: "valueOfProductsMatchCriteria",
    type: "itemsCriteria",
  },
  {
    attribute: "transaction.itemsCriteria.qty",
    data: null,
    label: "quantityOfProductsMatchCriteria",
    type: "itemsCriteria",
  },
  {
    label: "quantityOfFilteredTransaction",
    value: {
      field: "transaction.items.qty",
      aggregation: {
        type: "sum",
        field: "qty",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
  {
    label: "valueOfFilteredTransaction",
    value: {
      field: "transaction.items.grossValue",
      aggregation: {
        type: "sum",
        field: "grossValue",
      },
    },
    type: NewFormatConditionType.NUMBER,
  },
];

export const transactionDirectCampaignConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [...directCustomerConditions, ...transactionConditions];

export const transactionReferralCampaignConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [...referralCampaignCustomerConditions, ...transactionConditions];

export const achievementEventReferralCampaignConditions: (
  | CampaignCondition
  | CampaignConditionNewFormat
)[] = [...eventReferralCampaignConditions, ...achievementConditions];

export function getInitialDataForSelectedSchemaConditions(type: string) {
  switch (type) {
    case "datetime":
      return null;
    case "boolean":
      return false;
    default:
      return null;
  }
}
